import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '@/services/api'
import { API_ENDPOINTS, API_URL } from '@/config/api'
import router from '@/router'
import axios from 'axios'

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem('token'))
  const refreshToken = ref(localStorage.getItem('refreshToken'))
  const user = ref(null)

  const isAuthenticated = computed(() => !!token.value)

  async function login(credentials) {
    try {
      const response = await axios.post(`${API_URL}${API_ENDPOINTS.LOGIN}`, credentials, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      token.value = response.data.access
      refreshToken.value = response.data.refresh
      
      localStorage.setItem('token', token.value)
      localStorage.setItem('refreshToken', refreshToken.value)
      
      await fetchCurrentUser()
      router.push('/')
    } catch (error) {
      console.error('Login failed:', error)
      throw error
    }
  }

  async function refreshAccessToken() {
    try {
      const response = await axios.post(
        `${API_URL}${API_ENDPOINTS.REFRESH_TOKEN}`,
        { refresh: refreshToken.value },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
      token.value = response.data.access
      localStorage.setItem('token', token.value)
      return token.value
    } catch (error) {
      console.error('Token refresh failed:', error)
      logout()
      throw error
    }
  }

  async function fetchCurrentUser() {
    try {
      const response = await api.get(API_ENDPOINTS.CURRENT_USER)
      user.value = response.data
    } catch (error) {
      console.error('Failed to fetch user:', error)
      throw error
    }
  }

  function logout() {
    token.value = null
    refreshToken.value = null
    user.value = null
    localStorage.removeItem('token')
    localStorage.removeItem('refreshToken')
    router.push('/login')
  }

  return {
    token,
    refreshToken,
    user,
    isAuthenticated,
    login,
    refreshAccessToken,
    fetchCurrentUser,
    logout
  }
}) 